import './search-sources.styl';

import React from 'react';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';

const SearchSources = ({title, items = [], selected = '', onChange}) =>
  <div className="search-sources">
    <div className="search-sources__header">{title}: </div>
    <div className="search-sources__items">
      {items.map((item, key) =>
        <label
          className={classnames({
            'search-sources__item': true,
            'search-sources__item_checked': selected === item.value
          })}
          key={key}
        >
          <input
            type="radio"
            name="source"
            value={item.value}
            checked={selected === item.value}
            onChange={onChange}
          />
          <FormattedMessage
            className="search-sources__item-title"
            id={item.id}
            defaultMessage={item.name}
          />
          {/*<span className="search-sources__item-title">{item.name}</span>*/}
        </label>
      )}
    </div>
  </div>;

SearchSources.propTypes = {
  onChange: React.PropTypes.func.isRequired,
  items: React.PropTypes.array.isRequired,
  selected: React.PropTypes.string,
  title: React.PropTypes.string
};

export default SearchSources;



// WEBPACK FOOTER //
// ./src/client/components/search-sources/SearchSources.js